import React, { useState } from 'react';
import { Star } from 'lucide-react';

export default function StarRating({
  value = 0,
  size = 16,
  interactive = false,
  onChange,
  testId,
}) {
  const [hover, setHover] = useState(0);
  const display = interactive ? hover || value : value;

  return (
    <div className="flex items-center gap-0.5" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= Math.round(display);
        return (
          <button
            key={i}
            type="button"
            disabled={!interactive}
            onClick={() => interactive && onChange?.(i)}
            onMouseEnter={() => interactive && setHover(i)}
            onMouseLeave={() => interactive && setHover(0)}
            className={interactive ? 'cursor-pointer transition-transform hover:scale-110' : 'cursor-default'}
            aria-label={`${i} star${i > 1 ? 's' : ''}`}
          >
            <Star
              style={{ width: size, height: size }}
              className={
                filled
                  ? 'fill-[#0B4F3F] text-[#0B4F3F]'
                  : 'text-[#E4E8EF]'
              }
            />
          </button>
        );
      })}
    </div>
  );
}
